import React from "react";
import PropTypes from "prop-types";
import { Grid, Typography, Divider } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";

const TitledSection = ({ title, showDivider, children }) => {
  const theme = useTheme();
  return (
    <Grid container item xs={12}>
      <Typography style={{ padding: theme.spacing(2, 0) }} variant="h5">
        {title}
      </Typography>
      {children}
      {showDivider && (
        <Grid item xs={12} style={{ paddingTop: theme.spacing(3) }}>
          <Divider />
        </Grid>
      )}
    </Grid>
  );
};
TitledSection.propTypes = {
  title: PropTypes.string.isRequired,
  showDivider: PropTypes.bool,
  children: PropTypes.node,
};
TitledSection.defaultProps = {
  children: null,
  showDivider: true,
};

export default TitledSection;
